import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchIpaLessons } from "./ipaService";
import "./IpaPage.css";

const difficultyOptions = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];

const difficultyColor = (d) => {
  const map = { BEGINNER: "#4caf50", INTERMEDIATE: "#ff9800", ADVANCED: "#e91e63" };
  return map[d?.toUpperCase()] || "#999";
};

const IpaLessonListPage = () => {
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const res = await fetchIpaLessons({ page, size: 20, search: search || undefined, difficulty: difficulty || undefined });
    if (res.status === 200 && res.data?.status) {
      setLessons(res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      setLessons([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, search, difficulty]);

  useEffect(() => { load(); }, [load]);

  const handleDifficulty = (val) => { setPage(0); setDifficulty(difficulty === val ? "" : val); };

  return (
    <>
      <Navbar />
      <div className="ipa-page">
        <h1 className="ipa-title">📚 IPA Lessons</h1>
        <p className="ipa-subtitle">Structured lessons to master English pronunciation step by step.</p>

        <div className="ipa-filters">
          <input
            className="ipa-search"
            type="text"
            placeholder="Search lessons..."
            value={search}
            onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          />
        </div>

        <div className="ipa-tabs">
          {difficultyOptions.map((d) => (
            <button key={d} className={`ipa-tab ${difficulty === d ? "active" : ""}`} onClick={() => handleDifficulty(d)}>
              {d.charAt(0) + d.slice(1).toLowerCase()}
            </button>
          ))}
        </div>

        {totalItems > 0 && <p className="ipa-count">{totalItems} lessons found</p>}

        {loading ? (
          <p className="ipa-loading">Loading...</p>
        ) : lessons.length === 0 ? (
          <p className="ipa-empty">No lessons found.</p>
        ) : (
          <div className="ipa-lesson-grid">
            {lessons.map((l) => (
              <div key={l.id} className="ipa-lesson-card" onClick={() => navigate(`/study/ipa/lessons/${l.id}`)}>
                <div className="ipa-lesson-header">
                  <h3 className="ipa-lesson-title">{l.title}</h3>
                  <span className="ipa-difficulty-badge" style={{ background: difficultyColor(l.difficulty) }}>
                    {l.difficulty}
                  </span>
                </div>
                <p className="ipa-lesson-desc">{l.description}</p>
                <p className="ipa-lesson-meta">{l.symbolCount} sounds</p>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="ipa-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
            <span>Page {page + 1} / {totalPages}</span>
            <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default IpaLessonListPage;
